export default "__VITE_ASSET__Cn1Sk4af__"